module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"empty":"с нуля","express":"Экспресс-шаблон","text":"Не нашли подходящий шаблон? Создайте его с {scratch}, или используйте {express}."}}')
  delete Component.options._Ctor
}
